import { FunctionComponent } from "react";
import { mdiCurrencyUsd, mdiLeak } from "@mdi/js";
import Icon from "@mdi/react";
import { IconProps } from "@mdi/react/dist/IconProps";

import { NewLabelSVGIcon } from "components/SVGIcons";
import { IStepItem } from "models/Component";
import { GridCardItem } from "models/Base";
import { routes } from "./routes";

export const INVITED_CARRIER_DESCRIPTION_LIST = [
  { id: 0 },
  {
    id: 1,
    title: "Freight Payment Boarding",
    description: "Please make sure to confirm all of the following information."
  },
  {
    id: 2,
    title: "Freight Payment Boarding",
    description:
      "Please select your default payment option. You can ask the broker to change this later if needed."
  },
  {
    id: 3,
    title: "Thank You",
    description: "For boarding for payments via HaulPay."
  }
];

export const INVITED_CARRIER_ITEMS: GridCardItem[] = [
  {
    id: 0,
    label: "Connections",
    icon: (props: FunctionComponent<IconProps>) => <Icon path={mdiLeak} {...props} />,
    link: routes.HAULPAY_CARRIER_PAYMENT_PREFERENCE
  },
  {
    id: 1,
    label: "Assigned",
    icon: (props: React.SVGProps<SVGSVGElement>) => <NewLabelSVGIcon {...props} />,
    link: routes.HAULPAY_ASSIGNED_LOADS
  },
  {
    id: 2,
    label: "Factoring",
    icon: (props: FunctionComponent<IconProps>) => <Icon path={mdiCurrencyUsd} {...props} />,
    link: routes.HAULPAY_STATUS
  }
];

export const JOIN_HAULPAY_INVITED_STEP_LIST: IStepItem[] = [
  { id: 0, name: "Docs", description: "" },
  { id: 1, name: "Summary", description: "" }
];
